import {Product} from '../Product'

export class Generic extends Product {
  constructor(data, vm) {
    super(data, vm)
  }
}

Product.GENERIC = Generic
export default Generic
